import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import Agree from "@/components/Agree";
import Dashboard from "@/components/Dashboard";
import Reg from "@/components/Reg";
import Index from "@/components/welcome/index.vue";

import BookList from "@/components/role/list";

import OrgList from "@/components/org/list";

import UserList from "@/components/user/list";
import UserChangePwd from "@/components/user/changepwd";
import UserProfile from "@/components/user/profile";

import MenuList from "@/components/menu/list";

import FileList from "../components/file/List.vue";

import LogList from "../components/log/List";
//答题考试相关页面
import questionList from "../components/exam/questionbank";
import testpaper from "../components/exam/testpaper";
import userexam from "../components/exam/userexam";
import wantExam from "../components/exam/wantExam";
import orgReport from "../components/exam/orgReport";
import empReport from "../components/exam/empReport";
//设备相关页面
import deviceCategory from "@/components/device/deviceCategory";
import deviceSupplierCategory from "@/components/device/deviceSupplierCategory";
import device from "@/components/device/device";
import deviceEvent from "@/components/device/deviceEvent";
import deviceEventDictionary from "@/components/device/deviceEventDictionary";
import deviceSupplier from "@/components/device/deviceSupplier";
import deviceMap from "@/components/device/deviceMap";
import earth from "@/components/device/earth";
import monitor from "@/components/device/monitor";
import deviceBlue from "@/components/device/deviceBlue";

import screen from "@/components/screen";
import dictList from "@/components/dict/dictList";
import dictTypeList from "@/components/dict/dictTypeList";

import ProjectList from "@/components/project/projectList";
import ProjectDetail from "@/components/project/projectDetail";
import CommonTemplate from "@/components/project/templates/CommonTemplate";
import UserinfoTransTemplate from "@/components/project/templates/UserinfoTransTemplate";

//巡检、维保人员维护
import safeuser from "@/components/safeuser/list";
import workorder from "@/components/workorder/list";

import platform from "@/components/third/platform";
import Device from "@/components/third/device";

// 懒加载方式，当路由被访问的时候才加载对应组件
const Login = (resolve) => require(["@/components/Login"], resolve);

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/index",
      name: "首页",
      component: Index
    },
    {
      path: "/login",
      name: "登录",
      component: Login
    },
    {
      path: "/agree",
      name: "协议",
      component: Agree
    },
    {
      path: "/reg",
      name: "注册",
      component: Reg
    },
    {
      path: "/",
      name: "home",
      component: Home,
      redirect: "/screen",
      leaf: true, // 只有一个节点
      menuShow: true,
      iconCls: "fa fa-home", // 图标样式class
      children: [
        {
          path: "/dashboard",
          component: Dashboard,
          name: "首页",
          menuShow: true
        },
        {
          path: "/screen",
          component: screen,
          name: "大屏监控",
          menuShow: true
        },
        {
          path: "/project/list",
          component: ProjectList,
          name: "projectList",
          menuShow: true
        },
        {
          path: "/project/detail/:id",
          component: ProjectDetail,
          name: "projectDetail",
          children: [
            {
              path: "CommonTemplate/:deviceCategoryId",
              component: CommonTemplate,
              name: "CommonTemplate"
            },
            {
              path: "UserinfoTransTemplate/:deviceCategoryId",
              component: UserinfoTransTemplate,
              name: "UserinfoTransTemplate"
            }
          ]
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "首页",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/admin/dict",
          component: dictList,
          name: "字典列表",
          menuShow: true
        },
        {
          path: "/admin/dictType",
          component: dictTypeList,
          name: "字典类型列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "单位管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/admin/org",
          component: OrgList,
          name: "组织列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "用户管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/admin/user",
          component: UserList,
          name: "用户列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "菜单管理",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-server", // 图标样式class
      children: [
        {
          path: "/admin/menu",
          component: MenuList,
          name: "菜单列表",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "角色管理",
      menuShow: true,
      leaf: true,
      iconCls: "fa fa-group",
      children: [
        {
          path: "/admin/role",
          component: BookList,
          name: "角色管理",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "文件管理",
      menuShow: true,
      leaf: true,
      iconCls: "fa fa-group",
      children: [
        {
          path: "/cms/file",
          component: FileList,
          name: "文件管理",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "日志管理",
      menuShow: true,
      leaf: true,
      iconCls: "fa fa-group",
      children: [
        {
          path: "/base/log",
          component: LogList,
          name: "日志管理",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "设置",
      menuShow: true,
      iconCls: "iconfont icon-setting1",
      children: [
        {
          path: "/user/profile",
          component: UserProfile,
          name: "个人信息",
          menuShow: true
        },
        {
          path: "/user/changepwd",
          component: UserChangePwd,
          name: "修改密码",
          menuShow: true
        }
      ]
    },

    {
      path: "/",
      component: Home,
      name: "注册服务",
      menuShow: true,
      iconCls: "iconfont icon-setting1",
      children: [
        {
          path: "/service",
          component: UserProfile,
          redirect: "http://baidu.com",
          target: "_blank",
          name: "个人信息",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "设备管理",
      menuShow: true,
      leaf: false, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/device/earth",
          component: earth,
          name: "地磁管理",
          menuShow: true
        },
        {
          path: "/device/monitor",
          component: monitor,
          name: "地磁管理",
          menuShow: true
        },
        {
          path: "/device/device",
          component: device,
          name: "设备管理",
          menuShow: true
        },
        {
          path: "/device/deviceEvent",
          component: deviceEvent,
          name: "设备告警",
          menuShow: true
        },
        {
          path: "/device/deviceEventDictionary",
          component: deviceEventDictionary,
          name: "设备告警类型",
          menuShow: true
        },
        {
          path: "/device/deviceCategory",
          component: deviceCategory,
          name: "设备品类",
          menuShow: true
        },
        {
          path: "/device/deviceSupplierCategory",
          component: deviceSupplierCategory,
          name: "供应商设备品类",
          menuShow: true
        },
        {
          path: "/device/deviceSupplier",
          component: deviceSupplier,
          name: "设备供应商",
          menuShow: true
        },
        {
          path: "/device/deviceMap",
          component: deviceMap,
          name: "地图展示",
          menuShow: true
        },
        {
          path: "/device/deviceBlue",
          component: deviceBlue,
          name: "蓝天用传设备配置",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "考试中心",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/exam/list",
          component: questionList,
          name: "题库管理",
          menuShow: true
        },
        {
          path: "/exam/test",
          component: testpaper,
          name: "试卷管理",
          menuShow: true
        },
        {
          path: "/exam/user",
          component: userexam,
          name: "考试记录",
          menuShow: true
        },
        {
          path: "/exam/willexam",
          component: wantExam,
          name: "我要考试",
          menuShow: true
        },
        {
          path: "/exam/orglist",
          component: orgReport,
          name: "单位及格率",
          menuShow: true
        },
        {
          path: "/exam/userlist",
          component: empReport,
          name: "员工及格率",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "保障抢修",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/safeuser/list",
          component: safeuser,
          name: "保障人员",
          menuShow: true
        },
        {
          path: "/workorder/list",
          component: workorder,
          name: "工单查询",
          menuShow: true
        }
      ]
    },
    {
      path: "/",
      component: Home,
      name: "消防平台",
      menuShow: true,
      leaf: true, // 只有一个节点
      iconCls: "fa fa-user", // 图标样式class
      children: [
        {
          path: "/third/platform",
          component: platform,
          name: "平台管理",
          menuShow: true
        },
        {
          path: "/third/device",
          component: Device,
          name: "设备管理",
          menuShow: true
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  //console.log('to:' + to.path)
  if (to.path.startsWith("/reg")) {
    next();
  } else {
    if (to.path.startsWith("/login")) {
      window.localStorage.removeItem("access-user");
      next();
    } else if (to.path.startsWith("/index")) {
      next();
    } else {
      let user = window.localStorage.getItem("access-user");
      if (!user) {
        next({ path: "/login" });
      } else {
        next();
      }
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js